// Wraps a customer-assets.emergentagent.com URL through our own backend proxy
// so browsers don't block it via ORB on custom domains (luxetiniescapes.com).
// Also resolves relative /api/... paths to the configured backend origin.
// Also normalizes any Google Drive URL to the direct-image thumbnail form,
// which reliably serves the image bytes (uc?export=view is deprecated).
// Non-matching URLs pass through unchanged.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function proxied(url) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("https://customer-assets.emergentagent.com/")) {
    return `${BACKEND_URL}/api/asset-proxy?u=${encodeURIComponent(url)}`;
  }
  if (url.startsWith("/api/")) {
    return `${BACKEND_URL}${url}`;
  }
  // Google Drive → auto-normalize to the direct-image thumbnail form (heals legacy uc?export=view links).
  const gdrive = url.match(/drive\.google\.com\/(?:file\/d\/|open\?id=|uc\?[^ ]*[?&]id=|thumbnail\?[^ ]*[?&]id=)([a-zA-Z0-9_-]+)/);
  if (gdrive) {
    return `https://drive.google.com/thumbnail?id=${gdrive[1]}&sz=w2400`;
  }
  return url;
}
